import { useCallback } from 'react';

import { useSignedInDashboardContext } from '../../SignedInDashboardContextProvider';

import { useCareerFeedAIAssistant } from './useCareerFeedAIAssistant';

/**
 * This hook is used to reset the candidate chat context and refresh the recommendations
 */
export const useGetResetCandidateChatContext = () => {
  const { clearCandidateChatContext } = useCareerFeedAIAssistant();

  const {
    recommendationsResult: { refresh },
  } = useSignedInDashboardContext();

  const resetPreferences = useCallback(() => {
    clearCandidateChatContext();
    refresh({ candidateChatContext: null });
  }, [clearCandidateChatContext, refresh]);
  return resetPreferences;
};

/**
 * This hook is used to refresh the recommendations with the latest candidate chat context from the context.
 */
export const useGetRefreshRecommendationsWithCandidateChatContext = () => {
  const { candidateChatContext, persistCandidateChatContext, reset } =
    useCareerFeedAIAssistant();
  const {
    recommendationsResult: { refresh },
  } = useSignedInDashboardContext();

  return useCallback(async () => {
    await refresh({
      candidateChatContext,
    });
    persistCandidateChatContext();
    reset();
  }, [refresh, candidateChatContext, persistCandidateChatContext, reset]);
};
